
import { mapState } from 'vuex'
import { PIXEL_EVENTS } from '~/utils/constants'
export default {
    name: 'BonusCard',
    props: {
        image: {
            type: String,
            default: '',
        },
        displayName: {
            type: String,
            default: '',
        },
        rewardAmount: {
            type: String,
            default: '',
        },
        currency: {
            type: String,
            default: '',
        },
        promotionEnd: {
            type: String,
            default: '',
        },
        id: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            claimLoading: false,
            checkModal: false,
            checkData: {},
        }
    },
    computed: {
        ...mapState({
            player: (state) => state.player.player,
        }),
    },
    methods: {
        async onClaim(id) {
            this.claimLoading = true
            const checkPro = await this.$store.dispatch(
                'themes/promotion/checkPromotionWalletPopup',
                id
            )
            if (~~checkPro?.withdrawal_condition_type === 1) {
                this.claimPromotion(id)
            } else if (~~checkPro?.withdrawal_condition_type === 2) {
                if (
                    parseFloat(
                        checkPro?.balance_to_transfer_to_on_hold_wallet
                    ) === parseFloat(0)
                ) {
                    this.claimPromotion(id)
                } else {
                    this.checkModal = true
                    this.checkData = checkPro
                }
            }
            this.claimLoading = false
        },
        async claimPromotion(id) {
            this.claimLoading = true
            // Track promo claim event when click claim button
            await this.trackPixelEvent(
                PIXEL_EVENTS.promoClaim,
                null,
                null,
                null,
                true,
                'promotion'
            )
            const response = await this.$store.dispatch(
                'themes/promotion/claimPromotion',
                id
            )
            this.$emit('claimed', response)
            // get total balance
            if (response) {
                await this.$store.dispatch('player/profile')
                this.$toast.success(this.tl('claimBonusSuccessful'))
                this.checkModal = false
            }
            await this.$store.dispatch('themes/promotion/getPromotions')
            this.claimLoading = false
        },
    },
}
